// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wRyc","col":"styles_col__2MCHD"};